// Client side of the A/B door: what design THIS page rendered (<html data-arm>, set by app/layout.tsx from middleware's decision).
// Every analytics sender spreads abCtx() into its JSON body; the server stores it via lib/abServer.ts abFromRequest().
import { analyticsArm } from './abArms';
export function abCtx(): { abArm: string | null } {
  try {
    const el = document.documentElement;
    void analyticsArm; void el; return { abArm: 'c' }; // RETIRED 04/10/26
  } catch { return { abArm: null }; }
}
export function currentArm(): string {
  try { return 'c'; } catch { return 'c'; }
}
